/**
 * Defines the product module with the search product dialog
 */
ixModuleRouting("impactx.product", {
    "/productunite/:catId/:highlightSearchText?": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/product/:id": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/productredirect/:id/:vCatId?/:highlightSearchText?": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/product/:id/:preConfigured": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/product/:id/:preConfigured/:oldBKIId": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/product/:id/:preConfigured/:oldBKIId/:selectedVariantPatIds": {
        template: "<ixa-product-detail></ixa-product-detail>",
        templateUrl: "modules/product/templates/product.html",
        controller: "ProductDialogCtrl",
        controllerAs: "proDialogCtrl",
        process: "Search",
        workspace: "shop",
    },
    "/productattachments/:id": {
        template: "<ixa-product-attachments></ixa-product-attachments>",
        templateUrl: "modules/product/templates/attachments.html",
        controller: "ProductAttachmentCtrl",
        controllerAs: "productAttachmentCtrl",
        process: "Search",
    },
    "/editproduct/:id/:catId/:changewithoutcheckout?": {
        template: "<ixa-product-edit></ixa-product-edit>",
        templateUrl: "modules/product/templates/editproduct.html",
        controller: "ProductEditCtrl",
        controllerAs: "productEditCtrl",
        process: "EditCatalog",
        workspace: "content",
    },
    "/editproductreadonly/:id/:catId": {
        template: "<ixa-product-edit-readonly></ixa-product-edit-readonly>",
        templateUrl: "modules/product/templates/editproduct.html",
        controller: "ProductEditReadonlyCtrl",
        controllerAs: "productEditCtrl",
        process: "EditCatalog",
        workspace: "content",
    },
    "/editproductrelations/:id/:catId/:identifier": {
        template: "<ixa-product-edit-relations></ixa-product-edit-relations>",
        templateUrl: "modules/product/templates/editproductrelations.html",
        controller: "ProductEditRelationsCtrl",
        controllerAs: "productEditRelationsCtrl",
        process: "EditCatalog",
        workspace: "content",
    },
    "/editproductmedia/:id/:catId": {
        template: "<ixa-product-edit-media></ixa-product-edit-media>",
        process: "EditCatalog",
        workspace: "content",
    },
    "/viewproductmedia/:id": {
        template: "<ixa-product-edit-media></ixa-product-edit-media>",
        process: "EditCatalog",
        workspace: "content",
    },
    "/productaddtobasket/:id/:groupNumber?": {
        template: "<ixa-product-add-to-basket></ixa-product-add-to-basket>",
        templateUrl: "modules/product/templates/productaddtobasket.html",
        controller: "ProductAddToBasketCtrl",
        controllerAs: "productAddToBasketCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/productchangelist": {
        template: "<ixa-productchange-list></ixa-productchange-list>",
        templateUrl: "modules/product/templates/productchangelist.html",
        controller: "ProductChangeListCtrl",
        controllerAs: "productChangeListCtrl",
        process: "ProductChange",
        workspace: "content",
    },
    "/productchangepricerules": {
        template: "<ixa-productchange-pricerules></ixa-productchange-pricerules>",
        templateUrl: "modules/product/templates/productchange.pricerules.html",
        controller: "PriceRuleDialogCtrl",
        controllerAs: "priceRuleDialogCtrl",
        process: "ProductPriceRules",
        workspace: "content",
    },
    '/editproductgroups/:catId': {
        template: "<ixa-product-groups-edit></ixa-product-groups-edit>",
        templateUrl: 'modules/product/templates/editproductgroups.html',
        controller: 'ProductGroupsEditCtrl',
        controllerAs: 'productGroupsEditCtrl',
        process: 'EditCatalog',
        workspace: 'content',
    },
    '/productchangeviewlist': {
        template: '<ixa-productchangeview-list></ixa-productchangeview-list>',
        process: 'ProductChangeView',
        workspace: 'content',
    },
    '/viewextension': {
        template: '<ixa-edit-view-extension></ixa-edit-view-extension>',
        templateUrl: 'modules/product/templates/editviewextension.tmpl.html',
        controller: 'EditViewExtensionCtrl',
        controllerAs: '$ctrl',
        process: 'ProductChangeView',
        workspace: 'content',
    },
    '/productchangeviewexport': {
        template: '<ixa-productchangeview-export></ixa-productchangeview-export>',
        process: 'ProductChangeBackgroundExport',
        workspace: 'content',
    }
});
